const nailgunFeaturesJa = {
  // 4Vシリーズ
  product_J_120_feature_1_title: '極めて軽量で人間工学に基づいた設計',
  product_J_120_feature_1_desc: 'この機械はわずか0.9kgと軽量で、長時間の作業における手の疲労を大幅に軽減します。',
  product_J_120_feature_2_title: '无可比拟的电池续航',
  product_J_120_feature_2_desc: '1回の充電で1,000枚の撮影が可能で、類似製品と比較して優れたバッテリー寿命を誇ります。',
  product_J_120_feature_3_title: '最新のユニバーサル急速充電',
  product_J_120_feature_3_desc: '汎用的な急速充電インターフェースを採用しており、様々な電源からの急速充電に対応しているため、いつでもどこでもエネルギーを補給できます。',
  product_J_120_feature_4_title: '三重の安全保護',
  product_J_120_feature_4_desc: '集成安全触头、可视化储钉窗与 LED 指示灯，全方位保障安全。',
  product_J_120_feature_5_title: '75分急速充電',
  product_J_120_feature_5_desc: '4V 1.5Ahバッテリーはわずか75分で満充電、現場でのダウンタイムを最小限に抑えます。',

  product_J_125_feature_1_title: '0.7kgの超軽量ボディデザイン',
  product_J_125_feature_1_desc: '重さはわずか0.7kgで、ペットボトルよりも軽いため、繊細な作業でも容易に操作できます。',
  product_J_125_feature_2_title: '1000の超長距離射撃範囲',
  product_J_125_feature_2_desc: '1回の充電で1000回発射でき、高い耐久性により頻繁な充電は不要です。',
  product_J_125_feature_3_title: 'あらゆるタイプのネイルに対応',
  product_J_125_feature_3_desc: 'この多機能な3in1ステープラーは、53#、T50#ステープル、および47#/BN1810ストレートステープルに対応しています。',
  product_J_125_feature_4_title: '最適化されたセキュリティと監視',
  product_J_125_feature_4_desc: '二重の安全接点と透明な釘収納窓の組み合わせにより、より安全で集中した作業が可能になります。',
  product_J_125_feature_5_title: '80分充電サイクル',
  product_J_125_feature_5_desc: '付属の4V 1.5Ahバッテリーで80分充電、ノンストップ生産性のための素早い充電回転を実現します。',

  product_J_139_feature_1_title: 'T型釘汎用性（20〜50mm）',
  product_J_139_feature_1_desc: '20〜50mmのT型釘に対応し、家具組立、キャビネット背板、軽量構造作業に適しています。',
  product_J_139_feature_2_title: 'より強力な2.0Ahバッテリー',
  product_J_139_feature_2_desc: '標準1.5Ahモデルと比べてアップグレードされた4V 2.0Ahバッテリーで、充電ごとのショット数が多く中断を減らします。',
  product_J_139_feature_3_title: 'T型用80本マガジン',
  product_J_139_feature_3_desc: '80本のT型マガジンで家具組立やキャビネット背板作業を頻繁な補充なしに続けられます。',
  product_J_139_feature_4_title: '低騒音82dB運転',
  product_J_139_feature_4_desc: 'ノイズレベル≦82dBで動作し、室内ワークショップや住宅リノベーション環境に十分静かです。',
  product_J_139_feature_5_title: '85分急速充電',
  product_J_139_feature_5_desc: '85分でフル充電し、バッテリー交換中も現場の生産性を高く維持します。',

  product_J_126_feature_1_title: 'J型釘深打ち（25〜64mm）',
  product_J_126_feature_1_desc: '25〜64mmのJ型釘に対応し、厚みのある木製部品や構造的な廻り縁の取付けに最適です。',
  product_J_126_feature_2_title: '強力2.0Ah 4Vバッテリー',
  product_J_126_feature_2_desc: '4V 2.0Ahパックは緻密な硬木廻り縁や厚板材料でも安定した打ち込み力を発揮します。',
  product_J_126_feature_3_title: '75本J型マガジン',
  product_J_126_feature_3_desc: '75本のJ型釘を装填でき、中規模の家具やキャビネット作業に最適化された容量です。',
  product_J_126_feature_4_title: '誤射防止順次トリガー',
  product_J_126_feature_4_desc: '順次モードにより誤射を防止し、すべての釘が意図的かつ正確に打ち込まれます。',
  product_J_126_feature_5_title: '90分充電で長時間稼働',
  product_J_126_feature_5_desc: '90分で満充電、終日電源が限られる場所での作業に最適です。',

 product_J_153_feature_1_title: '3-in-1 オールインワン固定システム',
 product_J_153_feature_1_desc: 'T50#、53#ステープル、47#ストレート釘に対応しており、建設現場のニーズを完全に満たします。',
 product_J_153_feature_2_title: '超軽量でケーブル固定',
 product_J_153_feature_2_desc: '重量1.35kg。人間工学に基づいたデザインで、ワイヤーを素早く固定できる独自の金属製マガジンを採用。',
 product_J_153_feature_3_title: '高速連射と長寿命バッテリー',
 product_J_153_feature_3_desc: '毎分100発という高速で発射し、1回の充電で1800本の釘を発射できる。',
 product_J_153_feature_4_title: '精密な制御と安全性の確保',
 product_J_153_feature_4_desc: '工具不要の深さ調整ノブと安全接点により、誤作動を防ぎます。す。',
 product_J_153_feature_5_title: '75分急速充電',
 product_J_153_feature_5_desc: '4V 1.5Ahバッテリーを75分で急速充電し、一日中布張り作業をスケジュール通りに進めます。',

  product_lk_4v_n50_feature_1_title: 'N型構造釘範囲（20〜50mm）',
  product_lk_4v_n50_feature_1_desc: '20〜50mmのN型釘に対応し、木枠組み、フェンシング、デッキ板固定に使用します。',
  product_lk_4v_n50_feature_2_title: '重型120本マガジン',
  product_lk_4v_n50_feature_2_desc: '120本のN型釘を装填でき、大量枠組み作業でのリロード時間を大幅削減します。',
  product_lk_4v_n50_feature_3_title: '0.88kg堅固構造',
  product_lk_4v_n50_feature_3_desc: 'N型構造釘打ちに必要な追加の力を処理するため0.88kgとやや重く、振動を抑えます。',
  product_lk_4v_n50_feature_4_title: '高トルク順次打ち',
  product_lk_4v_n50_feature_4_desc: 'N型釘を硬木枠や構造木材に一定の深さで打ち込むための十分なパワーを発揮します。',
  product_lk_4v_n50_feature_5_title: '2.0Ah延長ランタイム',
  product_lk_4v_n50_feature_5_desc: '4V 2.0Ahバッテリーは充電間隔が長く、屋外フレーミングやデッキ設置に欠かせません。',

  product_lk_4v_b18_feature_1_title: 'B型精密釘精度（10〜18mm）',
  product_lk_4v_b18_feature_1_desc: '10〜18mmのB型釘で繊細な幅木、ビーディング、薄パネル取付けを割れなく実現します。',
  product_lk_4v_b18_feature_2_title: '110本マガジン容量',
  product_lk_4v_b18_feature_2_desc: '110本マガジンで部屋全体の幅木取付けを1回の装填で完了できます。',
  product_lk_4v_b18_feature_3_title: 'スリムボディ256mm',
  product_lk_4v_b18_feature_3_desc: '256mmのコンパクト本体で、内装廻り縁や装飾取付け時に狭いコーナーや隙間に入り込めます。',
  product_lk_4v_b18_feature_4_title: 'スムーズ順次打ち',
  product_lk_4v_b18_feature_4_desc: '順次モードにより、繊細な装飾端沿いに注意深く釘を配置でき、打ち過ぎのリスクがありません。',
  product_lk_4v_b18_feature_5_title: '1.5Ahバッテリー75分急速充電',
  product_lk_4v_b18_feature_5_desc: '軽量1.5Ahバッテリーでツールを機動的に保ちながら、わずか75分で満充電します。',

  product_lk_4v_c25_feature_1_title: 'C型釘範囲（12〜25mm）',
  product_lk_4v_c25_feature_1_desc: '12〜25mmのC型釘に対応し、薄から中程度の厚さのパネルや廻り縁固定の幅広いシナリオをカバーします。',
  product_lk_4v_c25_feature_2_title: '100本スムーズフィードマガジン',
  product_lk_4v_c25_feature_2_desc: 'スムーズフィード機構付き100本マガジンでジャムを防ぎ、釘打ちリズムを一定に保ちます。',
  product_lk_4v_c25_feature_3_title: 'バランスの良い0.77kg重量',
  product_lk_4v_c25_feature_3_desc: '0.77kgはC型ネイラーの打ち込み力と使用快適性の理想的なバランスポイントです。',
  product_lk_4v_c25_feature_4_title: '精密な順次釘位置決め',
  product_lk_4v_c25_feature_4_desc: '順次トリガー制御で繊細な木目や装飾面に沿って正確に釘を打てます。割れなし。',
  product_lk_4v_c25_feature_5_title: '80分充電でいつでも準備完了',
  product_lk_4v_c25_feature_5_desc: '4V 1.5Ahバッテリーは80分で充電でき、終日内装廻り縁作業に実用的です。',

  product_lk_4v_d30_feature_1_title: 'D型釘強度（15〜30mm）',
  product_lk_4v_d30_feature_1_desc: '信頼性の高い深さコントロールで15〜30mmのD型釘を打ち込み、中型廻り縁、ケーシング、パネル作業に対応します。',
  product_lk_4v_d30_feature_2_title: 'D型用90本マガジン',
  product_lk_4v_d30_feature_2_desc: '90本マガジンでマガジンサイズとツール重量のバランスを取り、終日廻り縁作業も快適です。',
  product_lk_4v_d30_feature_3_title: '硬い素材向け2.0Ahバッテリー',
  product_lk_4v_d30_feature_3_desc: '4V 2.0Ahパックでより緻密な木廻り縁やケーシングへの追加打ち込み力を提供し、バッテリー寿命を犠牲にしません。',
  product_lk_4v_d30_feature_4_title: '一定の深度調整',
  product_lk_4v_d30_feature_4_desc: '調整可能な打ち込み深さで様々な木材密度に対して面一またはカウンターシンク結果を実現、表面を傷つけません。',
  product_lk_4v_d30_feature_5_title: '85分急速充電',
  product_lk_4v_d30_feature_5_desc: '85分で充電完了、昼食休憩でバッテリーを交換して充電しても作業を続けるには十分な速さです。',

  product_lk_4v_e40_feature_1_title: 'E型釘延長リーチ（18〜40mm）',
  product_lk_4v_e40_feature_1_desc: '18〜40mmのE型釘をより厚みのある硬木廻り縁に打ち込み、幅広い廻り縁深さをカバーします。',
  product_lk_4v_e40_feature_2_title: '80本コンパクトマガジン',
  product_lk_4v_e40_feature_2_desc: '80本マガジンは長いE型釘向けに最適化され、ツールのコンパクトなサイズを維持します。',
  product_lk_4v_e40_feature_3_title: '0.83kgバランスボディ',
  product_lk_4v_e40_feature_3_desc: '0.83kgで重量級の釘打ちを実現、長時間使用でも手や手首を疲れさせないよう丁寧にバランスされています。',
  product_lk_4v_e40_feature_4_title: '精密深打ち順次モード',
  product_lk_4v_e40_feature_4_desc: '順次トリガーで可視木面への長い釘の正確な配置を完全にコントロールできます。',
  product_lk_4v_e40_feature_5_title: '90分充電、2.0Ah容量',
  product_lk_4v_e40_feature_5_desc: '4V 2.0Ahバッテリーは40mm釘打ちの高エネルギー需要に対応し、90分で満充電します。',

  // 20Vシリーズ
  product_J_128_feature_1_title: '20V Fネイルパワー（15〜30mm）',
  product_J_128_feature_1_desc: '20Vにアップグレードされたこのネイラーは大量廻り縁作業向けのプログレードパワーでフィニッシュネイルを打ち込みます。',
  product_J_128_feature_2_title: 'プログレード2.0Ah 20Vバッテリー',
  product_J_128_feature_2_desc: '20V 2.0Ahリチウムバッテリーで緻密な硬木や厚いケーシングでも強力で安定した打ち込み力を発揮します。',
  product_J_128_feature_3_title: '110本プロフェッショナルマガジン',
  product_J_128_feature_3_desc: '110本のFフィニッシュネイルを装填し、大規模内装廻り縁作業を中断なく続けられます。',
  product_J_128_feature_4_title: '60分急速充電サイクル',
  product_J_128_feature_4_desc: '20Vバッテリーはわずか60分で充電でき、製品シリーズ最速で、高強度現場に最適です。',
  product_J_128_feature_5_title: '2年間保証',
  product_J_128_feature_5_desc: '毎日ツールに依存するプロユーザー向けの完全24ヶ月保証。',

  product_J_129_feature_1_title: '20V Fネイルパワー（15〜30mm）',
  product_J_129_feature_1_desc: '20Vにアップグレードされたこのネイラーは大量廻り縁作業向けのプログレードパワーでフィニッシュネイルを打ち込みます。',
  product_J_129_feature_2_title: 'プログレード2.0Ah 20Vバッテリー',
  product_J_129_feature_2_desc: '20V 2.0Ahリチウムバッテリーで緻密な硬木や厚いケーシングでも強力で安定した打ち込み力を発揮します。',
  product_J_129_feature_3_title: '110本プロフェッショナルマガジン',
  product_J_129_feature_3_desc: '110本のFフィニッシュネイルを装填し、大規模内装廻り縁作業を中断なく続けられます。',
  product_J_129_feature_4_title: '60分急速充電サイクル',
  product_J_129_feature_4_desc: '20Vバッテリーはわずか60分で充電でき、製品シリーズ最速で、高強度現場に最適です。',
  product_J_129_feature_5_title: '2年間保証',
  product_J_129_feature_5_desc: '毎日ツールに依存するプロユーザー向けの完全24ヶ月保証。',

  product_J_133_feature_1_title: '2in1多機能デザイン',
  product_J_133_feature_1_desc: '18ゲージのF型ストレート釘と55ポンドのステープルに完全に互換性があり、多目的に使用できる機械です。',
  product_J_133_feature_2_title: '正確な深度調整と可視化ウィンドウ',
  product_J_133_feature_2_desc: '工具不要の深さ調整ノブとステープル収納窓付き',
  product_J_133_feature_3_title: '複数の安全機能と照明',
  product_J_133_feature_3_desc: '二重の安全接点により誤作動を防ぎ、内蔵型LED作業灯も付属しています。',
  product_J_133_feature_4_title: '効率的で耐久性のある動作',
  product_J_133_feature_4_desc: '毎分60発という高速で発射でき、1回の充電で1000本の釘を発射できる。',
  product_J_133_feature_5_title: '振動吸収グリップ',
  product_J_133_feature_5_desc: '防振グリップ設計で長いT型釘のツール反動を吸収し、重量級キャビネット作業の疲労を軽減します。',

  product_J_145_feature_1_title: '20V Fネイルパワー（15〜30mm）',
  product_J_145_feature_1_desc: '20Vにアップグレードされたこのネイラーは大量廻り縁作業向けのプログレードパワーでフィニッシュネイルを打ち込みます。',
  product_J_145_feature_2_title: 'プログレード2.0Ah 20Vバッテリー',
  product_J_145_feature_2_desc: '20V 2.0Ahリチウムバッテリーで緻密な硬木や厚いケーシングでも強力で安定した打ち込み力を発揮します。',
  product_J_145_feature_3_title: '110本プロフェッショナルマガジン',
  product_J_145_feature_3_desc: '110本のFフィニッシュネイルを装填し、大規模内装廻り縁作業を中断なく続けられます。',
  product_J_145_feature_4_title: '60分急速充電サイクル',
  product_J_145_feature_4_desc: '20Vバッテリーはわずか60分で充電でき、製品シリーズ最速で、高強度現場に最適です。',
  product_J_145_feature_5_title: '2年間保証',
  product_J_145_feature_5_desc: '毎日ツールに依存するプロユーザー向けの完全24ヶ月保証。',

  product_J_147_feature_1_title: 'Nネイルフレーミングパワー（40〜90mm）',
  product_J_147_feature_1_desc: 'デッキボード、フェンシング、重型構造フレーミングに使用する40〜90mmのN型フレーミングネイルを処理します。',
  product_J_147_feature_2_title: '最大150本フレーミングマガジン',
  product_J_147_feature_2_desc: '150本マガジンはラインアップ全体で最高容量で、フレーミングとデッキ作業に最大の生産性を発揮します。',
  product_J_147_feature_3_title: '終日フレーミング用4.0Ahバッテリー',
  product_J_147_feature_3_desc: '20V 4.0Ahバッテリーは1回の充電で何百本もの90mm釘を打ち込める拡張フレーミング時間をサポートします。',
  product_J_147_feature_4_title: '頑丈な1.78kgフレーミング構造',
  product_J_147_feature_4_desc: '重型1.78kg構造で大型N型フレーミングネイルの反動に耐え、照準を崩しません。',
  product_J_147_feature_5_title: '産業用87dBノイズコントロール',
  product_J_147_feature_5_desc: 'フレーミングネイラーで≦87dBに設計され、プロ施工業者の大半の現場ノイズ規制に準拠しています。',

  product_J_150_feature_1_title: '窒素スプリング駆動技術',
  product_J_150_feature_1_desc: '圧縮窒素スプリング構造を採用することで、遅延のない瞬時発射を実現しています。',
  product_J_150_feature_2_title: '1回の充電で優れたバッテリー寿命を実現',
  product_J_150_feature_2_desc: '1回の充電（2.0Ahバッテリー）で最大1200本の釘を打ち込むことができます。',
  product_J_150_feature_3_title: '18GA 2-in-1汎用性',
  product_J_150_feature_3_desc: '18ゲージ90ポンドステープルと18ゲージFストレートステープルに完全に互換性があります。',
  product_J_150_feature_4_title: 'ピーク稼働効率',
  product_J_150_feature_4_desc: '発射速度は毎分最大120発。',
  product_J_150_feature_5_title: '工具不要の深さ調整と素早いカード取り外し',
  product_J_150_feature_5_desc: '精密な調整ノブにより、一定のタッピング効果が得られ、オープンノズル設計により、詰まりを瞬時に除去できます。',

  product_J_156_feature_1_title: '2in1多機能デザイン',
  product_J_156_feature_1_desc: '18ゲージのF型ストレート釘と55ポンドのステープルに完全に互換性があり、多目的に使用できる機械です。',
  product_J_156_feature_2_title: '正確な深度調整と可視化ウィンドウ',
  product_J_156_feature_2_desc: '工具不要の深さ調整ノブとステープル収納窓付き',
  product_J_156_feature_3_title: '複数の安全機能と照明',
  product_J_156_feature_3_desc: '二重の安全接点により誤作動を防ぎ、内蔵型LED作業灯も付属しています。',
  product_J_156_feature_4_title: '効率的で耐久性のある動作',
  product_J_156_feature_4_desc: '毎分60発という高速で発射でき、1回の充電で1000本の釘を発射できる。',
  product_J_156_feature_5_title: '振動吸収グリップ',
  product_J_156_feature_5_desc: '防振グリップ設計で長いT型釘のツール反動を吸収し、重量級キャビネット作業の疲労を軽減します。',

  product_lk_20v_d70_feature_1_title: 'Dネイル深打ち（30〜70mm）',
  product_lk_20v_d70_feature_1_desc: '30〜70mmのD型釘を打ち込み、厚い構造廻り縁、ドア枠設置、重量木パネル取付けに対応します。',
  product_lk_20v_d70_feature_2_title: '105本頑丈マガジン',
  product_lk_20v_d70_feature_2_desc: '105本容量でポータビリティと持続的な構造廻り縁セッションの供給のバランスを取ります。',
  product_lk_20v_d70_feature_3_title: '密集打ち用4.0Ahバッテリー',
  product_lk_20v_d70_feature_3_desc: '20V 4.0Ahで70mmのD型釘を硬木に打ち込む追加エネルギーを提供し、安定した深度を維持します。',
  product_lk_20v_d70_feature_4_title: '調整可能排気デフレクター',
  product_lk_20v_d70_feature_4_desc: '回転可能な排気ポートで空気を顔や作業面から遠ざけ、集中使用時の使い勝手向上の機能です。',
  product_lk_20v_d70_feature_5_title: '60分急速充電',
  product_lk_20v_d70_feature_5_desc: '大容量4.0Ahバッテリーでも60分で充電でき、休憩後すぐに作業を再開できます。',

  product_lk_20v_e80_feature_1_title: 'Eネイル20V最大リーチ（35〜80mm）',
  product_lk_20v_e80_feature_1_desc: '35〜80mmのE型釘を厚い硬木、複合材料、重型構造フレーミング材に打ち込みます。',
  product_lk_20v_e80_feature_2_title: '100本ヘビーマガジン',
  product_lk_20v_e80_feature_2_desc: '大量の構造パネル設置や厚板釘打ちを想定したE型長尺釘用100本マガジンです。',
  product_lk_20v_e80_feature_3_title: '4.0Ahパワーパック',
  product_lk_20v_e80_feature_3_desc: '4.0Ahバッテリーで構造壁全体のセクションに80mmの釘を1回の充電で打ち続けられます。',
  product_lk_20v_e80_feature_4_title: '高反動用ラバーオーバーグリップ',
  product_lk_20v_e80_feature_4_desc: 'オーバーモールドゴムグリップで80mm釘打ちの大きな反動を吸収し、照準を維持しつつオペレーターの疲労を軽減します。',
  product_lk_20v_e80_feature_5_title: '1.72kg重型フレーム',
  product_lk_20v_e80_feature_5_desc: '1.72kg本体が打ち込みストレスを吸収し、重型フレーミング作業で真っ直ぐなプロ品質の結果を維持します。',

  product_lk_20v_g100_feature_1_title: 'Gネイル最大パワー（45〜100mm）',
  product_lk_20v_g100_feature_1_desc: '最長のGネイル45〜100mmで重型木材、柱フレーミング、厚い構造デッキ材の打ち込みを実現します。',
  product_lk_20v_g100_feature_2_title: '95本最大長マガジン',
  product_lk_20v_g100_feature_2_desc: '最長G型釘95本を装填でき、構造重型フレーミングや柱梁作業の高生産量に最適化されています。',
  product_lk_20v_g100_feature_3_title: '4.0Ah大容量ランタイム',
  product_lk_20v_g100_feature_3_desc: '4.0Ah 20Vバッテリーで1回の充電に何百本もの100mm釘を打ち込め、最も忙しいフレーミングチームにも追いつきます。',
  product_lk_20v_g100_feature_4_title: '55分超急速充電',
  product_lk_20v_g100_feature_4_desc: 'わずか55分で充電でき、シリーズ最速で大型構造フレーミングプロジェクトのダウンタイムを最小化します。',
  product_lk_20v_g100_feature_5_title: '1.92kgプロフレーミング本体',
  product_lk_20v_g100_feature_5_desc: '1.92kg本体で100mm釘を構造木材に一定に真っ直ぐ打ち込むために必要な質量と安定性を提供します。',

  // ACシリーズ
  product_J_112_feature_1_title: '絶え間なく続く原動力',
  product_J_112_feature_1_desc: '高性能交流動作専用に設計されており、あらゆる打撃において安定した発射力を保証します。',
  product_J_112_feature_2_title: '精密深度調整システム',
  product_J_112_feature_2_desc: '深さ調整ノブを備えているため、硬さの異なる木材でも完璧な皿穴加工効果が得られます。',
  product_J_112_feature_3_title: 'オールインワンの締結性能',
  product_J_112_feature_3_desc: '18ゲージF型ストレート釘および18ゲージ55ポンドステープルと完全に互換性があります。',
  product_J_112_feature_4_title: '工業グレードの堅牢な構造',
  product_J_112_feature_4_desc: '1.4kgのバランスの取れたボディと安全ロック機構の組み合わせにより、耐久性と精度に優れています。',
  product_J_112_feature_5_title: 'CE認証安全運転',
  product_J_112_feature_5_desc: 'CE安全認証でこのACネイラーがプロ使用の全欧州電気安全基準を満たすことを保証します。',

  product_J_115_feature_1_title: '最大重量0.6kgの軽量設計',
  product_J_115_feature_1_desc: '超軽量0.6kgのボディは携帯性の新たな基準を打ち立て、長時間の操作でも手の疲労を軽減します。',
  product_J_115_feature_2_title: '有源动力带来的无限一致性',
  product_J_115_feature_2_desc: 'プラグイン接続により、安定した強力な電力出力が確保され、リチウムイオンバッテリー搭載工具における電力減衰が完全に解消されます。',
  product_J_115_feature_3_title: 'オールインワン固定システム',
  product_J_115_feature_3_desc: '完美适配 53#, T50# 码钉及 47# 直钉，应对多种场景。',
  product_J_115_feature_4_title: 'セキュリティと視覚的監視を強化する',
  product_J_115_feature_4_desc: '安全ラッチと大きな透明窓の組み合わせにより、安全性が確保されるとともに、残りの釘の量を確認することができます。',
  product_J_115_feature_5_title: '1.85kgプロ本体',
  product_J_115_feature_5_desc: '1.85kgで日常的なプロの大量廻り縁作業の厳しさに耐えられる構造です。',

  product_J_118_feature_1_title: '最大重量0.6kgの軽量設計',
  product_J_118_feature_1_desc: '超軽量0.6kgのボディは携帯性の新たな基準を打ち立て、長時間の操作でも手の疲労を軽減します。',
  product_J_118_feature_2_title: '有源动力带来的无限一致性',
  product_J_118_feature_2_desc: 'プラグイン接続により、安定した強力な電力出力が確保され、リチウムイオンバッテリー搭載工具における電力減衰が完全に解消されます。',
  product_J_118_feature_3_title: 'オールインワン固定システム',
  product_J_118_feature_3_desc: '完美适配 53#, T50# 码钉及 47# 直钉，应对多种场景。',
  product_J_118_feature_4_title: 'セキュリティと視覚的監視を強化する',
  product_J_118_feature_5_title: '1.85kgプロ本体',
  product_J_118_feature_5_desc: '1.85kgで日常的なプロの大量廻り縁作業の厳しさに耐えられる構造です。',

  product_J_119_feature_1_title: '最大重量0.6kgの軽量設計',
  product_J_119_feature_1_desc: '超軽量0.6kgのボディは携帯性の新たな基準を打ち立て、長時間の操作でも手の疲労を軽減します。',
  product_J_119_feature_2_title: '有源动力带来的无限一致性',
  product_J_119_feature_2_desc: 'プラグイン接続により、安定した強力な電力出力が確保され、リチウムイオンバッテリー搭載工具における電力減衰が完全に解消されます。',
  product_J_119_feature_3_title: 'オールインワン固定システム',
  product_J_119_feature_3_desc: '完美适配 53#, T50# 码钉及 47# 直钉，应对多种场景。',
  product_J_119_feature_4_title: 'セキュリティと視覚的監視を強化する',
  product_J_119_feature_5_title: '1.85kgプロ本体',
  product_J_119_feature_5_desc: '1.85kgで日常的なプロの大量廻り縁作業の厳しさに耐えられる構造です。',

  product_J_123_feature_1_title: '0.71kgの超軽量コンパクト設計',
  product_J_123_feature_1_desc: '重量わずか0.71kgと、同クラスのアクティブネイルガンの中では最軽量であり、片手で簡単に操作でき、手の疲労を軽減します。',
  product_J_123_feature_2_title: '無制限のバッテリー寿命により、連続動作をサポートします。',
  product_J_123_feature_2_desc: '直接交流電源供給により、安定した途切れることのない電力供給が保証され、充電を待つ必要がなくなります。',
  product_J_123_feature_3_title: 'あらゆる状況に対応できる3in1の締結性能',
  product_J_123_feature_3_desc: '53番、T50番ステープル、47番ストレートステープルと完全に互換性があり、様々な場面に適しています。',
  product_J_123_feature_4_title: '統合セキュリティと視覚監視',
  product_J_123_feature_4_desc: '安全接点により誤作動を防ぎ、残量表示窓で残量をリアルタイムで確認できます。',
  product_J_123_feature_5_title: '2.15kgフレーミンググレード本体',
  product_J_123_feature_5_desc: '2.15kgの産業構造でフレーミングレベルの反動を吸収し、90mmの釘を並べて打つ際の精度を維持します。',

  product_lk_ac_b50_feature_1_title: 'AC Bネイル連続打ち（20〜50mm）',
  product_lk_ac_b50_feature_1_desc: '継続的なAC電源で20〜50mmのB型釘を打ち込み、量産環境や大量廻り縁ショップに最適です。',
  product_lk_ac_b50_feature_2_title: '850W安定打ち込みモーター',
  product_lk_ac_b50_feature_2_desc: '一定の850Wモーター出力でショットごとの深度変動を防ぎ、プロ品質の仕上がりに不可欠です。',
  product_lk_ac_b50_feature_3_title: '120本B型マガジン',
  product_lk_ac_b50_feature_3_desc: '1回の装填で120本のB型釘を供給し、長い内装ケーシングや階段廻り縁作業を補充なしで継続できます。',
  product_lk_ac_b50_feature_4_title: 'プラグイン信頼性',
  product_lk_ac_b50_feature_4_desc: 'バッテリー不要でダウンタイムなし。AC設計は安定した電源がある工場環境に最適です。',
  product_lk_ac_b50_feature_5_title: '1.88kgワークショップグレード',
  product_lk_ac_b50_feature_5_desc: '堅固な1.88kg品質で工場環境の耐久性と一貫性に最高の要求にも対応します。',

  product_lk_ac_c60_feature_1_title: 'AC Cネイル廻り縁（25〜60mm）',
  product_lk_ac_c60_feature_1_desc: 'AC電源で25〜60mmのC型釘を連続打ち込み、大量廻り縁設置に理想的に対応します。',
  product_lk_ac_c60_feature_2_title: '900W廻り縁モーター',
  product_lk_ac_c60_feature_2_desc: '900W ACモーターで斜め廻り縁材料にC型釘を跳ね返りなく打ち込むための力を発揮します。',
  product_lk_ac_c60_feature_3_title: '130本フルルームマガジン',
  product_lk_ac_c60_feature_3_desc: '130本容量で部屋全体の廻り縁設置を補充なしで完了できます。',
  product_lk_ac_c60_feature_4_title: '廻り縁作業用斜めノーズ',
  product_lk_ac_c60_feature_4_desc: '斜めノーズ設計で廻り縁コーナーへのアクセスが向上し、天井角度での面一釘打ちを確保します。',
  product_lk_ac_c60_feature_5_title: '1.95kg有線プロ構造',
  product_lk_ac_c60_feature_5_desc: '1.95kgで精密な頭上廻り縁釘打ちに必要な質量安定性を提供します。',

  product_lk_ac_d70_feature_1_title: 'AC Dネイル深打ち（30〜70mm）',
  product_lk_ac_d70_feature_1_desc: 'AC電源で30〜70mmのD型釘を継続的に打ち込み、緻密なドア枠、厚い構造廻り縁、ファシアボードに対応します。',
  product_lk_ac_d70_feature_2_title: '950W高トルクACモーター',
  product_lk_ac_d70_feature_2_desc: '950Wモーターで木材の密度や木目の方向に関わらず70mmの釘を一定の深さに打ち込みます。',
  product_lk_ac_d70_feature_3_title: '105本産業用マガジン',
  product_lk_ac_d70_feature_3_desc: '1回の装填で105本のD型釘を供給し、工場レベルのドア枠や構造廻り縁生産をサポートします。',
  product_lk_ac_d70_feature_4_title: 'アンチジャム釘フィードシステム',
  product_lk_ac_d70_feature_4_desc: '高度な釘フィード機構で緻密な硬木に70mmのD型釘を打ち込む際のジャムを防ぎます。',
  product_lk_ac_d70_feature_5_title: '2.08kg量産グレード重量',
  product_lk_ac_d70_feature_5_desc: '2.08kgの堅固な本体で何千発もの70mmの釘打ち衝撃を吸収し、ツールの正確な位置合わせを維持します。',

  product_lk_ac_e80_feature_1_title: 'AC Eネイル重型構造（35〜80mm）',
  product_lk_ac_e80_feature_1_desc: '無制限の220V AC電源で35〜80mmのE型釘を最も硬い構造材料に打ち込みます。',
  product_lk_ac_e80_feature_2_title: '1000W最大ACパワー',
  product_lk_ac_e80_feature_2_desc: 'フル1000Wモーター出力で長い作業セッション中もパワー低下なく大型80mmのE型釘を打ち込みます。',
  product_lk_ac_e80_feature_3_title: '100本E型マガジン',
  product_lk_ac_e80_feature_3_desc: '1回の装填で100本のE型釘を供給し、持続的な構造パネル設置や重型木フレーミング作業用に設計されています。',
  product_lk_ac_e80_feature_4_title: 'デュアルセーフティトリガーシステム',
  product_lk_ac_e80_feature_4_desc: '二重動作安全トリガーで大型80mm構造釘の誤射を防ぎ、安全な運転を実現します。',
  product_lk_ac_e80_feature_5_title: '2.18kg構造グレードフレーム',
  product_lk_ac_e80_feature_5_desc: '2.18kgはラインアップ最重のAC本体で、80mm構造釘打ちから最大の反動を吸収します。',

  product_lk_ac_g100_feature_1_title: 'AC Gネイル最大100mm打ち',
  product_lk_ac_g100_feature_1_desc: '最もパワフルなACネイラー、最重型構造フレーミング要件向けに45〜100mmのG型釘を継続的に打ち込みます。',
  product_lk_ac_g100_feature_2_title: '1200W産業用モーター',
  product_lk_ac_g100_feature_2_desc: '1200Wモーターはネイラーシリーズ全体で最高のパワー出力を誇り、硬木への100mmの釘打ちもためらいなくこなします。',
  product_lk_ac_g100_feature_3_title: '95本G型産業マガジン',
  product_lk_ac_g100_feature_3_desc: '最長G型釘95本を装填し、最も厚い構造用木材や重型デッキ板を貫通します。',
  product_lk_ac_g100_feature_4_title: '毎秒1.5発産業速度',
  product_lk_ac_g100_feature_4_desc: '100mmの釘でも毎秒最大1.5発の産業速度を実現し、重型木フレーミングチームのための産業速度です。',
  product_lk_ac_g100_feature_5_title: '2.35kg最大負荷構造',
  product_lk_ac_g100_feature_5_desc: '2.35kgは最大構造釘打ち向けに製造された最重ネイラーで、終日100mmの釘打ちの激しい反動を吸収します。',

  // アクセサリー — 4Vシリーズ
  //nail_4v_acc_1_name: '4V 2Ahリチウムバッテリー',
  //nail_4v_acc_1_desc: '超軽量設計、約800発/充電、約90分でフル充電、全4Vリチウム工具シリーズと互換性あり。',
  //nail_4v_acc_2_name: '4V USB急速充電器',
  //nail_4v_acc_2_desc: 'Type-C急速充電ポート、デュアルLED充電状態表示、全4Vリチウム工具シリーズと互換性あり。',
  //nail_4v_acc_3_name: '専用収納ケース',
  //nail_4v_acc_3_desc: 'ABSハードシェル＋精密成形EVAフォームインサート、本シリーズの形状にぴったりフィット、耐衝撃・防塵・防湿設計。',
  //nail_4v_acc_4_name: '超小型マガジン',
  //nail_4v_acc_4_desc: '100発装填可能な視覚式マガジン',
  //nail_4v_acc_5_name: '安全保護メガネ',
  //nail_4v_acc_5_desc: 'ポリカーボネート製耐衝撃レンズ、防曇コーティング、EN166建設安全規格準拠、軽量快適。',
  //nail_4v_acc_6_name: '回転式ベルトフッククリップ',
  //nail_4v_acc_6_desc: '304ステンレス鋼回転クリップ、360°スイベル、クイックアタッチ＆リリース、高頻度現場作業に最適。',
  //nail_4v_acc_7_name: 'クリーニング＆メンテナンスキット',
  //nail_4v_acc_7_desc: '防錆潤滑油、細毛クリーニングブラシ、ウエスを含む、定期使用により工具寿命を大幅延長。',
  //nail_4v_acc_8_name: '取扱説明書',
  //nail_4v_acc_8_desc: '中英日三言語対応の操作ガイド、安全警告、トラブルシューティング、全アクセサリー図解を収録。',

  // アクセサリー — 20Vシリーズ
  //nail_20v_acc_1_name: '20V 4Ahリチウムバッテリー',
  //nail_20v_acc_1_desc: '大容量設計、約2000発/充電、約60分でフル充電、全20Vリチウム工具シリーズと互換性あり。',
  //nail_20v_acc_2_name: '20V三段階LED急速充電器',
  //nail_20v_acc_2_desc: '三段階LED充電進捗表示、満充電自動カットオフ、全20Vリチウム工具シリーズと互換性あり。',
  //nail_20v_acc_3_name: '専用収納ケース',
  //nail_20v_acc_3_desc: 'ABSハードシェル＋精密成形EVAフォームインサート、本シリーズの形状にぴったりフィット、耐衝撃・防塵・防湿設計。',
  //nail_20v_acc_4_name: '専用釘（約1000本/箱）',
  //nail_20v_acc_4_desc: '高張力亜鉛メッキスチール釘、多種木材用途に対応、定期交換により最良の効果を維持。',
  //nail_20v_acc_5_name: '安全保護メガネ',
  //nail_20v_acc_5_desc: 'ポリカーボネート製耐衝撃レンズ、防曇コーティング、EN166建設安全規格準拠、軽量快適。',
  //nail_20v_acc_6_name: '回転式ベルトフッククリップ',
  //nail_20v_acc_6_desc: '304ステンレス鋼回転クリップ、360°スイベル、クイックアタッチ＆リリース、高頻度現場作業に最適。',
  //nail_20v_acc_7_name: 'クリーニング＆メンテナンスキット',
  //nail_20v_acc_7_desc: '防錆潤滑油、細毛クリーニングブラシ、ウエスを含む、定期使用により工具寿命を大幅延長。',
  //nail_20v_acc_8_name: '取扱説明書',
  //nail_20v_acc_8_desc: '中英日三言語対応の操作ガイド、安全警告、トラブルシューティング、全アクセサリー図解を収録。',

  // アクセサリー — ACシリーズ
  nail_ac_acc_1_name: 'AC 2m重型交換電源ケーブル',
  nail_ac_acc_1_desc: '3芯重型組み編みジャケットケーブル、耐屈曲・耐摩耗、有線ネイラーの長時間産業使用向け設計。',
  nail_ac_acc_2_name: 'サージ保護付き電源タップ',
  nail_ac_acc_2_desc: '内蔵サージ保護チップ、オン/オフスイッチ付き、過負荷自動遮断で工具の安全な使用を保護。',
  nail_ac_acc_3_name: '専用収納ケース',
  nail_ac_acc_3_desc: 'ABSハードシェル＋カスタムフォームインサート、本シリーズに完全フィット、耐衝撃で現場搬送に対応。',
  nail_ac_acc_4_name: '専用釘（約500本/箱）',
  nail_ac_acc_4_desc: '亜鉛メッキ高張力スチール釘、多種木材用途に対応、定期交換により最良の打ち込み効果を維持。',
  nail_ac_acc_5_name: '安全保護メガネ',
  nail_ac_acc_5_desc: 'ワイドポリカーボネート製耐衝撃レンズ、防曇コーティング、フルサイドシールド付き、EN166安全規格準拠。',
  nail_ac_acc_6_name: '作業台壁掛け収納ブラケット',
  nail_ac_acc_6_desc: '重型スチール製壁掛けラック、ネイラーの素早いアクセスと安定した直立収納をワークショップで実現。',
  nail_ac_acc_7_name: 'クリーニング＆メンテナンスキット',
  nail_ac_acc_7_desc: '防錆潤滑油、真鍮クリーニングブラシ、乾燥ウエスを含む、ノーズピースを清潔に保ちスムーズな送り込みを維持。',
  nail_ac_acc_8_name: '取扱説明書',
  nail_ac_acc_8_desc: '中英日三言語対応ガイド、メンテナンス周期、トラブルシューティング、交換部品図解を収録。',
};

export default nailgunFeaturesJa;
